import { Field } from "../types/field";
import { ConfigKey } from "../config/configHolder";

export const companyTypeValues = [
  { value: "LTD", label: "Public Limited" },
  { value: "PVT", label: "Private Limited" },
  { value: "LLP", label: "LLP" },
  { value: "PCO", label: "Partnership Co." },
  { value: "PRO", label: "Properitorship" },
  { value: "OPC", label: "One Person Company" },
];

export const companyFields: Field[] = [
  {
    name: "companyName",
    label: "Company Name",
    type: "text",
    props: {
      width: "25vw",
    },
  },
  {
    name: "section1",
    type: "formSection",
    childFields: [
      {
        name: "companyType",
        label: "Company Type",
        type: "picklist",
        allowUpdate: true,
        defaultValue: "LTD",
        values: companyTypeValues,
        props: {
          width: "12vw",
        },
      },
      {
        name: "companyCode",
        label: "Company Code",
        type: "text",
        autoFilled: true,
        allowNull: true,
        props: {
          width: "12vw",
        },
      },
    ],
  },
  {
    name: "section1",
    type: "formSection",
    childFields: [
      {
        name: "ownerFlg",
        label: "Project Owner",
        type: "checkbox",
        defaultValue: false,
        disability: {
          type: "OR",
          filters: [
            { type: "IN", field: "partnerFlg", values: [true] },
            // { type: "IN", field: "contractorFlg", values: [true] },
            { type: "IN", field: "foreignFlg", values: [true] },
            { type: "IN", field: ConfigKey.OWNER_FLAG_EDIT_ENABLED, values: [false] },
          ],
        },
        linkedFields: [
          {
            name: "partnerFlg",
            value: false,
          },
          {
            name: "foreignFlg",
            value: false,
          },
          {
            name: "contractorFlg",
            value: false,
          },
          {
            name: "supplierFlg",
            value: false,
          },
          {
            name: "serviceFlg",
            value: false,
          },
        ],
      },
      {
        name: "partnerFlg",
        label: "Partner",
        type: "checkbox",
        defaultValue: false,
        disability: {
          type: "OR",
          filters: [
            { type: "IN", field: "ownerFlg", values: [true] },
            { type: "IN", field: "foreignFlg", values: [true] },
            { type: "IN", field: ConfigKey.PARTNER_FLAG_EDIT_ENABLED, values: [false] },
          ],
        },
        linkedFields: [
          {
            name: "ownerFlg",
            value: false,
          },
          {
            name: "foreignFlg",
            value: false,
          },
          {
            name: "supplierFlg",
            value: false,
          },
          {
            name: "serviceFlg",
            value: false,
          },
        ],
      },
      {
        name: "foreignFlg",
        label: "Foreign",
        type: "checkbox",
        defaultValue: false,
        disability: {
          type: "OR",
          filters: [
            { type: "IN", field: "ownerFlg", values: [true] },
            { type: "IN", field: "partnerFlg", values: [true] },
            // { type: "IN", field: "contractorFlg", values: [true] },
          ],
        },
        linkedFields: [
          {
            name: "ownerFlg",
            value: false,
          },
          {
            name: "partnerFlg",
            value: false,
          },
          {
            name: "contractorFlg",
            value: false,
          },
          {
            name: "stationName",
            value: null,
          },
          {
            name: "stationCode",
            value: null,
          },
          {
            name: "stateName",
            value: null,
          },
          {
            name: "country",
            value: null,
          },
          {
            name: "panNo",
            value: null,
          },
          {
            name: "gstFlg",
            value: false,
          },
        ],
      },
    ],
  },
  {
    name: "address1",
    label: "Address1",
    type: "text",
    defaultValue: "",
    allowUpdate: true,
    props: {
      width: "25vw",
    },
  },
  {
    name: "address2",
    label: "Address2",
    type: "text",
    defaultValue: "",
    allowUpdate: true,
    allowNull: true,
    props: {
      width: "25vw",
    },
  },
  {
    name: "section2",
    type: "formSection",
    childFields: [
      {
        name: "stationName",
        label: "Station Name",
        props: {
          width: "17vw",
        },
        type: "lookup",
        allowUpdate: true,
        lookupType: "station",
        lookupFilter: {
          type: "AND",
          filters: [
            {
              type: "EQUALS",
              field: "foreignFlg",
              resolveValue: true,
              valueFieldName: "foreignFlg",
            },
          ],
        },
        dependentFields: [
          {
            lookupFieldName: "id",
            fieldName: "stationCode",
          },
          {
            additionalFieldName: "details",
            lookupFieldName: "stateCode",
            fieldName: "stateCode",
          },
          {
            additionalFieldName: "details",
            lookupFieldName: "stateName",
            fieldName: "stateName",
          },
          {
            additionalFieldName: "details",
            lookupFieldName: "country",
            fieldName: "country",
          },
        ],
      },
      {
        name: "stationCode",
        label: "Station Code",
        props: {
          width: "7vw",
        },
        type: "text",
        autoFilled: true,
      },
    ],
  },
  {
    name: "section2",
    type: "formSection",
    childFields: [
      {
        name: "stateName",
        label: "State Name",
        type: "text",
        autoFilled: true,
        defaultValue: "",
        disability: {
          type: "IN",
          field: "foreignFlg",
          values: [true],
        },
        props: {
          width: "12vw",
        },
      },
      {
        name: "country",
        label: "Country",
        type: "text",
        autoFilled: true,
        props: {
          width: "12vw",
        },
      },
    ],
  },
  {
    name: "section2",
    type: "formSection",
    childFields: [
      {
        name: "panNo",
        label: "Pan Number",
        type: "text",
        defaultValue: "",
        disability: {
          type: "IN",
          field: "foreignFlg",
          values: [true],
        },
        props: {
          width: "12vw",
        },
      },
      {
        name: "compBucket",
        label: "Comp Bucket",
        type: "text",
        autoFilled: true,
        allowNull: true,
        props: {
          width: "5.5vw",
        },
      },
      {
        name: "id",
        label: "Company Id",
        type: "text",
        autoFilled: true,
        allowNull: true,
        props: {
          width: "5.5vw",
        },
      },
    ],
  },
  {
    name: "section3",
    type: "formSection",
    childFields: [
      {
        name: "contractorFlg",
        label: "Contractor",
        type: "checkbox",
        defaultValue: false,
        disability: {
          type: "OR",
          filters: [
            { type: "IN", field: "ownerFlg", values: [true] },
            { type: "IN", field: "foreignFlg", values: [true] },
          ],
        },
        linkedFields: [
          {
            name: "ownerFlg",
            value: false,
          },
          {
            name: "foreignFlg",
            value: false,
          },
        ],
      },
      {
        name: "supplierFlg",
        label: "Supplier",
        type: "checkbox",
        defaultValue: false,
        disability: {
          type: "OR",
          filters: [
            { type: "IN", field: "ownerFlg", values: [true] },
            { type: "IN", field: "partnerFlg", values: [true] },
          ],
        },
        allowUpdate: true,
      },
      {
        name: "serviceFlg",
        label: "Transporter",
        type: "checkbox",
        defaultValue: false,
        disability: {
          type: "OR",
          filters: [
            { type: "IN", field: "ownerFlg", values: [true] },
            { type: "IN", field: "partnerFlg", values: [true] },
          ],
        },
        allowUpdate: true,
      },
    ],
  },
  {
    name: "section4",
    type: "formSection",
    childFields: [
      {
        name: "gstFlg",
        label: "GST Registered",
        type: "checkbox",
        defaultValue: false,
        disability: {
          type: "IN",
          field: "foreignFlg",
          values: [true],
        },
      },
      {
        name: "active",
        label: "Active",
        type: "checkbox",
        allowUpdate: true,
        defaultValue: false,
      },
    ],
  },
];

export const companyColumns = [
  {
    name: "companyCode",
    label: "Company",
    type: "text",
  },
  {
    name: "companyName",
    label: "Company Name",
    type: "text",
  },
  {
    name: "panNo",
    label: "Pan Number",
    type: "text",
  },
  {
    name: "stationName",
    label: "Station",
    type: "text",
  },
  {
    name: "stateName",
    label: "State",
    type: "text",
  },
  {
    name: "ownerFlg",
    label: "Owner",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "partnerFlg",
    label: "Partner",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  // {
  //   name: "foreignFlg",
  //   label: "Foreign",
  //   type: "text",
  //   format: (value) => (value ? "True" : "False"),
  // },
  // {
  //   name: "country",
  //   label: "Country",
  //   type: "text",
  // },
  {
    name: "contractorFlg",
    label: "Contractor",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "supplierFlg",
    label: "Supplier",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "serviceFlg",
    label: "Transporter",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "active",
    label: "Active",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "id",
    label: "Id",
    type: "text",
  },
];

export const companyExcelColumns = [
  {
    name: "companyCode",
    label: "Company Code",
    type: "text",
  },
  {
    name: "companyName",
    label: "Company Name",
    type: "text",
  },
  {
    name: "companyType",
    label: "Company Type",
    type: "text",
    format: (value) => companyTypeValues.find((item) => item.value === value).label,
  },
  {
    name: "ownerFlg",
    label: "Project Owner",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "partnerFlg",
    label: "Partner",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "foreignFlg",
    label: "Foreign",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "address1",
    label: "Address1",
    type: "text",
  },
  {
    name: "address2",
    label: "Address2",
    type: "text",
  },
  {
    name: "stationName",
    label: "Station",
    type: "text",
  },
  {
    name: "stateName",
    label: "State",
    type: "text",
  },
  {
    name: "country",
    label: "Country",
    type: "text",
  },
  {
    name: "panNo",
    label: "Pan Number",
    type: "text",
  },
  {
    name: "contractorFlg",
    label: "Contractor",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "supplierFlg",
    label: "Supplier",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "serviceFlg",
    label: "Transporter",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "gstFlg",
    label: "GST Registered",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "active",
    label: "Active",
    type: "text",
    format: (value) => (value ? "True" : "False"),
  },
  {
    name: "id",
    label: "Company Id",
    type: "text",
  },
];

export const companySearchColumns = [
  {
    name: "companyCode",
    label: "Company Code",
    type: "text",
  },
  {
    name: "companyName",
    label: "Company Name",
    type: "text",
    props: {
      widthFactor: 1.4,
    },
  },
  {
    name: "panNo",
    label: "Pan Number",
    type: "text",
  },
  {
    name: "ownerFlg",
    label: "Owner",
    type: "picklist",
    defaultValue: "",
    values: [
      { value: true, label: "True" },
      { value: false, label: "False" },
    ],
    props: {
      widthFactor: 0.8,
    },
  },
  {
    name: "partnerFlg",
    label: "Partner",
    type: "picklist",
    defaultValue: "",
    values: [
      { value: true, label: "True" },
      { value: false, label: "False" },
    ],
    props: {
      widthFactor: 0.8,
    },
  },
  // {
  //   name: "stationName",
  //   label: "Station",
  //   type: "text",
  // },
  // {
  //   name: "stateName",
  //   label: "State",
  //   type: "text",
  // },
  // {
  //   name: "country",
  //   label: "Country",
  //   type: "text",
  // },
  // {
  //   name: "foreignFlg",
  //   label: "Foreign",
  //   type: "picklist",
  //   defaultValue: "",
  //   values: [
  //     { value: true, label: "True" },
  //     { value: false, label: "False" },
  //   ],
  //   props: {
  //     widthFactor: 0.8,
  //   },
  // },
  {
    name: "contractorFlg",
    label: "Contractor",
    type: "picklist",
    defaultValue: "",
    values: [
      { value: true, label: "True" },
      { value: false, label: "False" },
    ],
    props: {
      widthFactor: 0.8,
    },
  },
  {
    name: "supplierFlg",
    label: "Supplier",
    type: "picklist",
    defaultValue: "",
    values: [
      { value: true, label: "True" },
      { value: false, label: "False" },
    ],
    props: {
      widthFactor: 0.8,
    },
  },
  {
    name: "serviceFlg",
    label: "Transporter",
    type: "picklist",
    defaultValue: "",
    values: [
      { value: true, label: "True" },
      { value: false, label: "False" },
    ],
    props: {
      widthFactor: 0.8,
    },
  },
  {
    name: "active",
    label: "Active",
    type: "picklist",
    defaultValue: "",
    values: [
      { value: true, label: "True" },
      { value: false, label: "False" },
    ],
    props: {
      widthFactor: 0.6,
    },
  },
];
